class NotificationWithoutCookies {
    constructor(props) {
        this.settings = {
            ...props,
            time: {
                tts: parseInt(props.selector.dataset.noncookie_tts), // time til notification is shown to the user
                ttl: parseInt(props.selector.dataset.noncookie_ttl), // time to live (displaying notification)
                ttsa: parseInt(props.selector.dataset.noncookie_ttsa) // time to show again
            }
        }

        this.notify = this.settings.selector;

        this.handleControls();
        this.showNotification(this.settings.time.tts);
    }

    /**
     * Disable Notification after TTL expired
     */
    setTTL = () => {
        if (!this.notify.querySelector('.notify-footer').classList.contains('show-action')) {
            this.settings.selector.classList.remove('show')
            this.showNotification(this.settings.time.ttsa);
        }
    }

    /**
     * Show Notification and set TTL
     */
    showNotification = timing => {
        setTimeout(() => {
            this.settings.selector.classList.add('show')
            this.timeoutTTL = setTimeout(this.setTTL, this.settings.time.ttl);
        }, timing)
    }

    /**
     * Inits Controls of widget
     */
    handleControls = () => {
        this.controls.showAction() // shows action elements of widget
        this.controls.hideAction() // hides action elements of widget
        this.controls.closeNotification() // close widget element
    }

    /**
     * @desc All Widget controls
     */
    controls = {
        showAction: () => {
            this.notify.querySelector('.toggle-action').addEventListener('click', () => this.widgetEvents.showActionControlsEvent())
        },
        hideAction: () => {
            this.notify.querySelector('.dismis').addEventListener('click', () => this.widgetEvents.hideActionControlsEvent())
        },
        closeNotification: () => {
            this.notify.querySelector('.notify-close').addEventListener('click', Event => this.widgetEvents.closeNotificationEvent(Event))
        }
    }

    /**
     * @desc All Widget events
     */
    widgetEvents = {
        showActionControlsEvent: () => {
            this.notify.querySelector('.notify-footer').classList.add('show-action')
            clearTimeout(this.timeoutTTL);
        },
        hideActionControlsEvent: () => {
            this.notify.querySelector('.notify-footer').classList.remove('show-action')
            this.showNotification()
        },
        closeNotificationEvent: () => {
            this.settings.selector.classList.remove('show')
        }
    }
}

if(document.querySelector('#newsletter-notification')) {
    // new NotificationWithoutCookies({selector: document.querySelector('#newsletter-notification')})
}
